import { type RefObject, useMemo, useState, useSyncExternalStore } from 'react';

function useHeightObserver(ref: RefObject<HTMLElement>): number {
  const [height, setHeight] = useState<number>(0);

  function subscribe(callback: () => void) {
    const resizeObserver = new ResizeObserver(entries => {
      setHeight(entries[0].contentBoxSize[0].blockSize);
      callback();
    });
    const element = ref.current;
    if (element) {
      resizeObserver.observe(element);
    }
    return () => resizeObserver.disconnect();
  }

  const dimensions = useSyncExternalStore(
    subscribe,
    () => height,
    () => height,
  );

  return useMemo(() => dimensions, [dimensions]);
}

export { useHeightObserver };
